// src/routes/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApiAuth } from '../contexts/ApiAuthContext';
import { toast } from 'react-hot-toast';
import { BRAND_COLORS, SYSTEM_COLORS } from '../constants/brandPalette';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, hasPermission, loading } = useApiAuth();
  const location = useLocation();

  // Show loading state
  if (loading) {
    return (
      <div
        className="flex items-center justify-center min-h-screen"
        style={{ backgroundColor: SYSTEM_COLORS.shellBackground }}
      >
        <div
          className="w-8 h-8 border-b-2 rounded-full animate-spin"
          style={{ borderColor: BRAND_COLORS.primary }}
        />
      </div>
    );
  }

  // If user is not authenticated, redirect to login
  if (!user) {
    // Only show error if not coming from logout
    if (!location.state?.isLogout) {
      toast.error('Please sign in to access this page');
    }
    return <Navigate to="/login" state={{ from: location.pathname, isLogout: location.state?.isLogout }} replace />;
  }

  // Check if user has required permission
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;